import { useRef } from 'react';
import { useDismiss } from '../dismiss.ts';
import { useT, type MsgKey } from '../i18n.ts';

// OS-native Unicode emoji only (no image sets, no external SDK).
const SETS: Array<[MsgKey, string]> = [
  ['emoji_smileys', '😀 😃 😄 😁 😅 😂 🙂 😉 😊 😍 🤩 😘 😋 😎 🤔 🤨 😐 😑 😶 🙄 😏 😬 😌 😴 😷 🤒 🥲 😢 😭 😤 😠 😡 🤯 😳 🥵 🥶 😱 😨 😰 😓 🤗 🤝 🫡'],
  ['emoji_gestures', '👍 👎 👌 ✌️ 🤞 🙏 👏 🙌 💪 👋 ✋ 👆 👇 👉 👈 ☝️ 🫶 🤙 ✊ 👊'],
  ['emoji_work', '📦 🚚 🚢 ✈️ 🏭 🔧 🔩 ⚙️ 🛠️ 🔌 🔋 💡 🖥️ 💻 📱 🎧 🎤 🔊 📷 📄 📑 📊 📈 📉 📅 🗓️ ⏰ ⏳ ✅ ☑️ ❌ ⚠️ 🔍 🧾 💰 💵 💶 💴 🏷️ 📝 📌 📎 🔒'],
  ['emoji_symbols', '❤️ 🧡 💛 💚 💙 💜 🖤 🤍 💯 ✔️ ❗ ❓ ‼️ ⭐ 🌟 🔥 🎉 🎊 🏆 🥇 🆗 🆕 🔴 🟠 🟡 🟢 🔵 ⬆️ ⬇️ ➡️ ⬅️ 🔄 ➕ ➖'],
  ['emoji_flags', '🇸🇪 🇨🇳 🇹🇼 🇭🇰 🇬🇧 🇺🇸 🇩🇪 🇳🇴 🇩🇰 🇫🇮 🇪🇺 🇯🇵 🇰🇷 🇻🇳'],
];

export const QUICK_REACTIONS = ['👍', '✅', '❤️', '😂', '😮', '🙏'];

export function EmojiPicker({ onPick, onClose }: { onPick: (e: string) => void; onClose: () => void }) {
  const t = useT();
  const ref = useRef<HTMLDivElement>(null);
  useDismiss(ref, true, onClose);
  return (
    <div className="emoji-picker" ref={ref} role="dialog" aria-label={t('react')}>
      {SETS.map(([label, set]) => (
        <section key={label}>
          <h3>{t(label)}</h3>
          <div className="emoji-grid">
            {set.split(' ').map((e) => (
              <button key={e} type="button" className="emoji-btn" onClick={() => onPick(e)} aria-label={e}>
                {e}
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
